import React, { FC } from "react"

interface IBarProps {
    width: string
    height: string
    color: string
    bgColor: string
}

const Bar: FC<IBarProps> = ({ width, height, color, bgColor }: IBarProps) => {
    return (
        <div
            style={{
                height: height,
                width: width,
                marginRight: "1px",
                backgroundColor: bgColor,
                color: color,
                alignSelf: "flex-end",
                textAlign: "center",
            }}
        ></div>
    )
}

export default Bar
